export const Successes: { [k: string]: any } = {
  SAVE_SUCCESS: "Saved successfully",
  SUBMIT: "Submitted successfully",
};
